import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";

 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import { featurePaths } from "@feature/constants/paths.constant";

const TrafficJobListPage = lazy(() => import("@feature/pages/TrafficJobList"));
const UpdateTrafficJobPage = lazy(() => import("@feature/pages/UpdateTrafficJob"));
 const VehicleBookingSummaryPage = lazy(() => import("@feature/pages/VehicleBookingSummary"));
 const UpdateVehicleBookingSummaryPage = lazy(() => import("@feature/pages/UpdateVehicleBookingSummary"));
 const BookingPrintPage = lazy(() => import("@feature/pages/BookingPrintPage"));
 const QuestionnaireFormPage = lazy(() => import("@feature/pages/QuestionnaireForm"));
 const ExhibitorBookingFormPage = lazy(() => import("@feature/pages/ExhibitorBookingForm"));
 const EmailTemplateListPage = lazy(() => import("@feature/pages/TrafficEmailList"));
 const UpdateEmailTemplatePage = lazy(() => import("@feature/pages/UpdateTrfcEmailTemplate"));
 const ViewQuestionnaireAnswersPage = lazy(() => import("@feature/helpers/QuestionnaireAnswers"));

// const ReturnSenderInstructionPage = lazy(() => import("@feature/pages/ReturnSenderInstruction"));
@injectable()
@registry([{ token: FeatureToken, useClass: TrafficJobList }])
class TrafficJobList implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "TrafficJob List",
                path: featurePaths.TrafficJobList,
                page: TrafficJobListPage
            },
            {
                title: "Update JOb",
                path: featurePaths.UpdateTrafficJob,
                page: UpdateTrafficJobPage
            }
            ,
            {
                title: "Vehicle Booking Summary",
                path: featurePaths.TrafficScheduleManifest,
                page: VehicleBookingSummaryPage
            } ,
            {
                title: "Update Vehicle Booking Summary",
                path: featurePaths.UpdateVehicleBookingSummary,
                page: UpdateVehicleBookingSummaryPage
            }
            ,
            {
                title: "Booking Print",
                path: featurePaths.BookingPrint,
                page: BookingPrintPage
            }
            ,
            {
                title: "Questionnaire Form",
                path: featurePaths.QuestionnaireForm,
                page: QuestionnaireFormPage
            },
            {
                title: "Exhibitor Booking Form",
                path: featurePaths.ExhibitorBookingForm,
                page: ExhibitorBookingFormPage
            },
            {
                title: "Traffic Email Template List",
                path: featurePaths.TrafficEmailTemplateList,
                page: EmailTemplateListPage
            },
            {
                title: "Update Traffic Email Template",
                path: featurePaths.UpdateTrafficEmailTemplate,
                page: UpdateEmailTemplatePage
            },
            {
                title: "View Questionnaire Answers",
                path: featurePaths.ViewQuestionnaireAnswers,
                page: ViewQuestionnaireAnswersPage
            }

        ]
    };
}
